import { useKonamiCode } from "@/hooks";
import loading from "@/images/loading.gif";
import logo from "@/images/svgs/viper.svg";
import styled from "styled-components";

const KonamiStyle = styled.img`
  background-color: white;
  height: 90px;
  width: 90px;
  z-index: 100;
  margin-top: 45px;
`;

export const ViperLogo = () => {
  const showKonami = useKonamiCode();
  return showKonami ? (
    <KonamiStyle src={loading} alt="Milwaukee Tool" />
  ) : (
    <img height={30} width={30} src={logo} alt="VIPER" />
  );
};
